import * as React from 'react'
import {Alert, Button, Modal, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {
    EmployeeItem,
    EmployeeStore,
    EmployeeSummary,
    IdentityUserSummary,
    NewEmployeeItem
} from 'src/stores/employees-store';
import {connect} from 'redux-scaffolding-ts'
import {clone} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {formatMessage} from 'src/core/services/http.service';

export interface EmployeeLinkerViewProps {
    visible?: boolean;
    employee?: EmployeeSummary;
    companyId: string;
    onClose: (id?: string, item?: NewEmployeeItem) => void;
    onDelete: (id: number) => void;
}

export interface EmployeeLinkerViewState {
    isBusy: boolean;
    employee?: EmployeeItem;
    user?: IdentityUserSummary;
    isIdentityUserFound?: boolean;
    error?: string;
}

@connect(["employees", EmployeeStore])
class NewEmployeeView extends React.Component<EmployeeLinkerViewProps & WithTranslation, EmployeeLinkerViewState> {
    tip: string = "Loading matching Identity user...";
    private get employeeStore() {
        return (this.props as any).employees as EmployeeStore;
    }

    constructor(props: EmployeeLinkerViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            isBusy:false
        }
    }

    @autobind
    componentDidMount() {
        this.load();
    }

    @autobind
    componentDidUpdate(prev: EmployeeLinkerViewProps) {
        if (prev.employee?.id != this.props.employee?.id || (prev.visible != this.props.visible && this.props.visible)) {
            this.load();
        }
    }

    @autobind
    private load() {
        this.tip = "Loading matching Identity user..."
        if (this.props.employee) {
            this.setState({ isBusy: true, error: undefined })
            this.employeeStore.changeUrl(this.props.companyId);
            this.employeeStore.getById(this.props.employee!.id as any).then(employee => {
                this.employeeStore.getIdentityUser(employee.id as any).then(result => {
                    if (result) {
                        this.setState({ isBusy: false, isIdentityUserFound: true, user: result, employee: employee })
                    } else {
                        this.setState({ isBusy: false, isIdentityUserFound: false })
                    }
                }).catch(reason => {
                    this.setState({ isBusy: false, isIdentityUserFound: false, error: reason.message })
                })
            }).catch(reason => {
                this.setState({ isBusy: false, isIdentityUserFound: false, error: reason.message })
            })
        }
    }

    @autobind
    private pair() {
        if (this.state.user === undefined || !this.state.isIdentityUserFound || this.state.employee === undefined) {
            return;
        }

        this.tip = "Pairing employee with Identity user..."
        this.setState({ isBusy: true })
        let employee = clone(this.state.employee!) as EmployeeItem
        employee.identityName = this.state.user.id
        employee.name = `${this.state.user.firstName??""} ${this.state.user.lastName??""}`
        employee.isUnlinked = false
        this.employeeStore.update(employee).then(result => {
            if (this.props.onClose) {
                this.props.onClose(result.identifier)
            }
        }).catch(reason => {
            this.setState({ isBusy: false, error: reason.message })
        })
    }

    public render() {
        const { t } = this.props;
        return (
            <Modal
            visible={this.props.visible}
            closable={false}
            title={t("Pair employee")}
            width={800}
            footer={[
                <Button
                    key="back"
                    onClick={() => { if (this.props.onClose) { this.props.onClose() } }}>
                    {t("Cancel")}
                </Button>,

                <Button
                    hidden={this.state.error === undefined || this.state.user !== undefined}
                    key="reload"
                    type="dashed"
                    loading={this.state.isBusy}
                    onClick={this.load}>
                    {t("Retry")}
                </Button>,

                <Button
                    hidden={this.state.error !== undefined}
                    key="delete"
                    type="danger"
                    loading={this.state.isBusy}
                    onClick={() => { if (this.props.onDelete && this.props.employee && !this.state.isBusy) { this.props.onDelete(this.props.employee.id) } }}>
                    {t("Delete")}
                </Button>,

                <Button
                    hidden={!this.state.isIdentityUserFound}
                    key="submit"
                    type="primary"
                    loading={this.state.isBusy}
                    onClick={this.pair}>
                    {t("Pair")}
                </Button>,
                ]}>
                {this.state.error && <Alert
                    type="error"
                    message={t('An error has occurred')}
                    description={formatMessage(this.state.error)}
                />}
                <Spin spinning={this.state.isBusy} tip={t(this.tip)}>
                    {!this.state.isIdentityUserFound && t('There is no Identity user matching with the employee. Do you wish to delete the employee?')}
                    {this.state.isIdentityUserFound && this.state.user && t('You wish to pair this employee with the Identity user') + ` "${this.state.user?.email}"` + "?"}
                    {!this.state.isIdentityUserFound && !this.state.user && this.state.error && t('Failed to load Identity user...')}
                </Spin>
            </Modal>    
            );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(NewEmployeeView as any) as any as React.ComponentClass<EmployeeLinkerViewProps>;